import PageShell from "./Page";
import PageHeader from "./PageHeader";
import PageNavigation from "./PageNavigation";
import PageSection from "./PageSection";
import PageMain from "./PageMain";

const Page = {
  Shell: PageShell,
  Header: PageHeader,
  Section: PageSection,
  Navigation: PageNavigation,
  Main: PageMain,
};

export default Page;
